const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;

export const runtimeConfig = {
  apiBaseUrl: rawApiBaseUrl?.replace(/\/$/, '') ?? '',
  flyBackendOrigin: 'https://api.chartify.xyz',
} as const;

export function apiUrl(path: `/api/${string}`): string {
  return `${runtimeConfig.apiBaseUrl}${path}`;
}
